var _radialGradient, _radialGradient2, _linearGradient, _linearGradient2, _radialGradient3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFranceLoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 44.235,
    cy: 41.937,
    r: 31.68,
    gradientTransform: "matrix(.9461 0 0 .776 -13.893 -21.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#043c8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#115eb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#1c7ad3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#238be8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#2591ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#1a76ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#043c8a"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 111.614,
    cy: 56.83,
    r: 22.213,
    gradientTransform: "translate(-13.893 -28.391) scale(.9461)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2591ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    stopColor: "#043c8a"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.501,
    y1: 0.934,
    x2: 0.498,
    y2: -0.259
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#001559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#001a60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#002673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#022b79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#073a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#1053a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#1b75cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2591ef"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.503,
    y1: 0.889,
    x2: 0.496,
    y2: -0.26
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#001559"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#001a60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#002673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#022b79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#073a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#1053a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#1b75cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2591ef"
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 101.256,
    cy: 51.583,
    r: 5.698,
    gradientTransform: "translate(-13.893 -28.391) scale(.9461)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    stopColor: "#ac0001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#c10002"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da0004"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.337 36.385h62.601v27.003H9.337c-2.585 0-4.699-2.123-4.699-4.718V41.112c0-2.604 2.104-4.727 4.699-4.727z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.663 47.424 11.256-11.03h8.01v27.003h-8.237l-11.03-10.813a3.6 3.6 0 0 1 0-5.161z",
    fill: "#002673"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#001559"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m54.031 47.424 11.256-11.03h8.01v27.003H65.06L54.03 52.584a3.6 3.6 0 0 1 0-5.161z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.71 47.424 71.854 30.62a3.79 3.79 0 0 1 5.274 0l17.143 16.804a3.6 3.6 0 0 1 0 5.161L77.128 69.388a3.8 3.8 0 0 1-5.274-.009L54.71 52.585a3.6 3.6 0 0 1 0-5.161z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m55.494 47.537 16.464-16.124a3.65 3.65 0 0 1 5.057 0L93.47 47.537a3.453 3.453 0 0 1 0 4.953L77.015 68.605a3.632 3.632 0 0 1-5.057 0L55.494 52.49a3.453 3.453 0 0 1 0-4.953z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.566 58.321c-2.396 0-8.614-.075-8.68-.075l-.764-.009.34-.689c.009-.019.906-1.878 1.396-5.378.538-3.887 2.783-5.708 3.085-5.831.113-.047.208-.075 1.623-.075l1.311.009.547.009-.264 2.019-.085.104c-.009.009-.821 1.066-1.057 2.991a30.58 30.58 0 0 1-.623 3.453h1.783c.5-.123 4.699-1.274 5.293-4.368.623-3.293-1.925-5.227-2.387-5.321-.057-.009-.415-.028-2.274-.028l-13.02.104-.821 3.085 5.17.009-1.217 3.925-5.01.019-1.604 6.01-5.416.019L12.64 41.3l20.7.038c.113 0 2.623.066 4.576 1.717 2.038 1.736 2.746 6.869.632 10.162-1.934 2.991-5.227 5.104-7.982 5.104z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.526 57.793 4.482-16.03 20.332.038s2.425.038 4.265 1.604 2.529 6.435.538 9.529c-1.991 3.085-5.17 4.906-7.586 4.906-2.425 0-8.671-.075-8.671-.075s.934-1.887 1.444-5.519c.5-3.632 2.604-5.378 2.783-5.453.179-.066 2.746-.038 2.746-.038l-.179 1.349s-.906 1.123-1.161 3.236c-.255 2.104-.755 4-.755 4h2.463s5.019-1.132 5.708-4.765c.689-3.642-2.132-5.784-2.774-5.897-.66-.113-15.756.075-15.756.075l-1.076 4.048 5.152.009-.915 2.963-5.029.009-1.604 6.01H8.526z",
    fill: "#fbfdf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.275 59.048c-2.378 0-4.972-1.849-5.085-1.925l-.481-.34 3.614-3.397.292.585c.009.019.311.547 1.161.547l.236-.009c1.094-.113 2.472-.802 2.821-3.397.283-2.104.972-4.831 1.283-6.029H41.88l.925-3.123.793-.528 8.359-.057v2.189l-.34.104s-.604.283-.802 1.84l-.085.66c-.283 2.312-.821 6.614-1.764 8.256-.934 1.632-2.991 3.802-5.67 4.51a5.029 5.029 0 0 1-1.019.113z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.747 41.895 7.727-.057v1.34s-.887.274-1.142 2.236-.793 7.01-1.793 8.746c-.991 1.727-2.972 3.651-5.378 4.283-2.406.642-5.689-1.727-5.689-1.727l2.708-2.547s.472.944 1.887.802c1.406-.151 2.887-1.094 3.246-3.821s1.444-6.576 1.444-6.576H42.53l.689-2.33.528-.349zm23.663 20.21 2.368-2.472c1.245-1.349 1.604-1.962 1.604-1.962l.057 2.113-1.83 2.897-1.038 1.378s-1.038-.311-1.255-.83c-.217-.528.094-1.123.094-1.123zm6.293-11.539s-3.01-3.246-6.746-3.255c-3.727-.009-5.519.925-5.869 2.481-.34 1.566.33 3.132 1.104 3.84s.736.368.811 1.321c.066.962-.359 4.019 2.774 4.18 3.142.16 5.925-3.595 7.029-5.378 1.104-1.774.896-3.189.896-3.189zm.255-2.151s-4.085-1.378-6.237-3.793-2.189-4.727-1.047-5.991c1.142-1.274 3.755-.896 4.17-1.019.415-.132 1.104-1.293 2.227-1.679 1.123-.377 2.906-.651 4.095 1.274 1.198 1.925.726 4.51.255 6.237-.33 1.255-1.453 3.736-2.302 4.802-.349.415-.944.198-1.161.17zm-.472 6.237c-.528 1.33-.906 2.925-.83 4.529.066 1.604.594 3.095 1.293 3.868.708.783 1.878 1.076 2.897.887 1.01-.179 1.632-.651 2.236-1.161.594-.509.726-.764 1.151-.821.434-.057 2.132.132 3.491-.868 1.349-1 1.33-3.359.481-4.67-.5-.783-2.057-2.236-3.283-3.151-1.085-.83-3.746-1.991-4.718-1.962-1.076.038-2.378 2.463-2.717 3.349zm5.991-11.671c.085-.132.189-.264.274-.377 1.566-2.057 3.774-2.595 5.293-2.264 1.519.321 2.264 1.472 2.463 2.708s-.057 1.812.123 2.217c.189.396 1.915 1.34 1.84 3.642-.066 2.312-2.312 3.198-4.265 3.368a8.35 8.35 0 0 1-2.179-.123l2.906-6.199-6.454-2.972z",
    fill: "#fbfdf5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.458 48.65c.453-1.019 1.472-3.18 2.481-4.84l5.746 2.491-2.529 5.67c-.802-.198-1.538-.472-2.161-.698a33.796 33.796 0 0 1-3.576-1.689c-.368-.255-.094-.623.038-.934z",
    fill: "url(#e)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFranceLoto);
export default __webpack_public_path__ + "static/media/france_loto.847dfdbf96fa5b64c8881afe97634b4c.svg";
export { ForwardRef as ReactComponent };